import api from '../config/axiosConfig';

export const MarcaParametrosService = {
    getByMarcaId: async ({ token, marca_id }) => {
        try {
            const response = await api.get(`/marcas/parametros/${marca_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcaParametrosService.getByMarcaId:', error);
            throw error;
        }
    },
    crearParametro: async ({ token, data }) => {
        try {
            const response = await api.post('/marcas/parametros', data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcaParametrosService.crearParametro:', error);
            throw error;
        }
    },
    editarParametro: async ({ token, id, data }) => {
        try {
            const response = await api.put(`/marcas/parametros/${id}`, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcaParametrosService.editarParametro:', error);
            throw error;
        }
    },
    eliminarParametro: async ({ token, id }) => {
        try {
            const response = await api.delete(`/marcas/parametros/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcaParametrosService.eliminarParametro:', error);
            throw error;
        }
    },
};
